import _get from "lodash/get";
import styled, { css } from 'styled-components';
import alertTheme from '../../styles/alertTheme';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "rjwjcq-0"
})(["align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;left:0;position:absolute;right:0;top:0;z-index:1;", ""], function (_ref) {
  var theme = _ref.theme,
      isFullScreen = _ref.isFullScreen;
  return isFullScreen && css(["background-color:", ";position:fixed;z-index:999;"], _get(theme, 'alert.alertFeedback.backgroundColor', alertTheme.alert.alertFeedback.backgroundColor));
});
export default Container;